/**
 * Theo dõi thao tác gần nhất của người dùng để phân biệt việc đóng modal do
 * bấm ra ngoài (backdrop/overlay) với đóng bằng nút X / nút Hủy / phím Esc.
 * Primer Dialog (cả bản v1 lẫn drafts) đều gọi cùng 1 callback đóng cho các trường hợp này.
 */
let lastPointerDownOutsideDialog = false;
let installed = false;

const install = () => {
    if (installed || typeof document === 'undefined') return;
    installed = true;
    document.addEventListener('pointerdown', (e: PointerEvent) => {
        const target = e.target as HTMLElement | null;
        lastPointerDownOutsideDialog = !(target && target.closest && target.closest('[role="dialog"]'));
    }, true);
    document.addEventListener('keydown', () => {
        // Thao tác bàn phím (Esc, Enter...) không phải là bấm ra ngoài
        lastPointerDownOutsideDialog = false;
    }, true);
};

install();

/** true nếu yêu cầu đóng modal hiện tại xuất phát từ việc bấm ra ngoài modal. */
export const isCloseByOutsideClick = (): boolean => lastPointerDownOutsideDialog;

/** Bọc hàm đóng: bỏ qua khi người dùng bấm ra ngoài modal. */
export function preventOutsideClose<T extends (...args: any[]) => any>(fn?: T): T | undefined {
    if (!fn) return fn;
    return ((...args: any[]) => {
        if (isCloseByOutsideClick()) return;
        return fn(...args);
    }) as T;
}

